import { render, staticRenderFns } from "./AggregatorList.vue?vue&type=template&id=6983f98a&"
import script from "./AggregatorList.vue?vue&type=script&lang=js&"
export * from "./AggregatorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports